var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"close":"","color":"primary"},on:{"click":function($event){return _vm.$emit('click', $event)},"click:close":function($event){return _vm.$emit('click:close', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }